import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import { cn } from '@/lib/styles'
import type { GridCardProps } from '@/types/general'
import type { ServerRenderedEntry } from '@/types/helpers'
import { AppsCard } from './variants/AppsCard'
import { CompetitorsCard } from './variants/CompetitorsCard'
import { FileFormatCard } from './variants/FileFormatCard'
import { IntegrationsCard } from './variants/IntegrationsCard'
import { IntegrationsWithDescriptionCard } from './variants/IntegrationsWithDescriptionCard'

export function Tile(
	props: ServerRenderedEntry<
		GridCardProps & {
			variant: Data.Component<'shared.tile'>['variant']
			className?: string
			asLink?: boolean
		}
	>,
) {
	const { variant, className, asLink = true, ...tileParams } = props

	const commonClassName = cn(
		'group focus:outline-none w-full flex rounded-xl border relative border-neutral-light-600 transition-colors duration-200 hover:border-brand-salmon focus-visible:border-brand-salmon active:bg-neutral-light-200 h-full items-baseline group-data-[state=active]:border-brand-salmon group-data-[state=active]:cursor-default',
		className,
	)

	let variantComponent = null

	switch (variant) {
		case 'fileFormat':
			variantComponent = <FileFormatCard {...tileParams} />
			break
		case 'competitors':
			variantComponent = <CompetitorsCard {...tileParams} />
			break
		case 'integrations':
			variantComponent = <IntegrationsCard {...tileParams} />
			break
		case 'integrationsWithDescription':
			variantComponent = <IntegrationsWithDescriptionCard {...tileParams} />
			break
		case 'apps':
			variantComponent = <AppsCard {...tileParams} />
			break
		default:
			variantComponent = null
	}

	return asLink ? (
		<AppLink
			href={props.link?.href ?? '#'}
			openExternalInNewTab={props.link?.newTab ?? false}
			className={commonClassName}
		>
			{variantComponent}
		</AppLink>
	) : (
		<div
			className={cn(
				commonClassName,
				'flex relative flex-row items-center gap-1 justify-center cursor-pointer',
			)}
		>
			{variantComponent}
		</div>
	)
}
